import { sensorDataApi, SensorDataDto } from "../api/sensorDataApi";
import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";

const initialState: SensorDataDto[] = [];

const sensorDataSlice = createSlice({
    name: "sensorData",
    initialState,
    reducers: {
        setSensorData: (state, action: PayloadAction<SensorDataDto[]>) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(sensorDataApi.endpoints.getSensorData.matchFulfilled, (state, action) => {
            return action.payload;
        })
    }
})

export const { setSensorData } = sensorDataSlice.actions;
const sensorDataReducer = sensorDataSlice.reducer;
export { sensorDataReducer };